export const graficosRelatorioFilaMethods = {
  updateChart(response) {
    this.organizaDadosCardsEDonut(response)
    this.organizaDadosGraficoArea('porHora', this.dataLinePorHora, response.datasMediaPorHora)
    this.organizaDadosGraficoArea('TmPorHora', this.dataLineTmPorHora, response.datasMediaPorHora)
    this.organizaDadosGraficoArea('porDia', this.dataLinePorDia, response.datasMediaPorDia)
    this.organizaDadosGraficoArea('TmPorDia', this.dataLineTmPorDia, response.datasMediaPorDia)
    this.preencheTabelaLigacoesPorHora(response.datasPorHora)
    this.preencheTabelaLigacoesPorDia(response.datasMediaPorDiaCorridos)
  },

  organizaDadosCardsEDonut(response) {
    this.cardTotal = response.total
    this.cardAbandonadas = response.Abandonadas
    this.cardTimeout = response.timeout
    this.cardAtendidas = response.atendidas

    this.progressValueAtendidas = Number(this.cardAtendidas) / Number(this.cardTotal)
    this.progressValueAtendidas = this.progressValueAtendidas.toFixed(2) * 100

    this.progressValueAbandonadas = Number(this.cardAbandonadas) / Number(this.cardTotal)
    this.progressValueAbandonadas = this.progressValueAbandonadas.toFixed(2) * 100

    this.progressValueTimeout = Number(this.cardTimeout) / Number(this.cardTotal)
    this.progressValueTimeout = this.progressValueTimeout.toFixed(2) * 100

    this.progressValueNivelServico = (Number(response.atendidas) / Number(response.total)) * 100

    this.series.splice(0)

    this.series.push(Number(this.cardAtendidas))
    this.series.push(Number(this.cardAbandonadas))
    this.series.push(Number(this.cardTimeout))
    this.series.splice(0, 1, this.series[0])
  },

  organizaDadosGraficoArea(type, data, datasMedia) {
    let valores = Object.values(datasMedia)
    let keys = Object.keys(datasMedia)

    if (type === 'porHora' || type === 'TmPorHora') {
      keys = keys.map(hora => `${hora}:00`)
    }

    if (type === 'porHora') {
      const title = 'Ligações por Hora'
      this.configuraOptionsGraficoAreaChamadas(data, valores, keys, title)
    } else if (type === 'TmPorHora') {
      const title = 'Tempos por Hora'
      this.configuraOptionsGraficoAreaTempos(data, valores, keys, title)
    } else if (type === 'porDia') {
      const title = 'Ligações por Dia do Mês'
      this.configuraOptionsGraficoAreaChamadas(data, valores, keys, title)
    } else if (type === 'TmPorDia') {
      const title = 'Tempos por Dia do Mês'
      this.configuraOptionsGraficoAreaTempos(data, valores, keys, title)
    }
  },
}
